import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { ArrowPathIcon } from "@heroicons/react/24/solid";
import { CameraIcon } from "@heroicons/react/24/outline";
import { addShopBrand } from "../../../../redux/reducer/shopBrandReducer";

const AddShopBrandsForm = ({ onClose }) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const [nameEn, setNameEn] = useState("");
  const [nameAr, setNameAr] = useState("");
  const [websitelink, setWebsitelink] = useState("");
  const [image, setImage] = useState(null);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 bg-opacity-30bg-black">
      <div className="bg-white p-6 rounded-md w-[90%] max-w-lg shadow-xl space-y-4">
        <h2 className="text-xl font-bold text-center text-black">
          Add a New Item
        </h2>

        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Name EN"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-sm"
            value={nameEn}
            onChange={(e) => setNameEn(e.target.value)}
            required
          />
        </div>
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Name AR"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-sm"
            value={nameAr}
            onChange={(e) => setNameAr(e.target.value)}
            required
          />
        </div>

        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Website link"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-sm"
            value={websitelink}
            onChange={(e) => setWebsitelink(e.target.value)}
            required
          />
        </div>
        <div className="flex items-center gap-2">
          {/* Hidden File Input */}
          <input
            id="upload-image"
            type="file"
            accept="image/*"
            className="hidden"
            onChange={(e) => setImage(e.target.files[0])}
            required
          />

          {/* Custom Button */}
          <label
            htmlFor="upload-image"
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white transition bg-black border border-black cursor-pointer hover:bg-gray-800"
          >
            <CameraIcon className="w-4 h-4" />
            Add a picture
          </label>

          {/* Optional: show file name */}
          {image && <span className="text-xs text-gray-600">{image.name}</span>}
        </div>

        <div className="flex justify-end gap-4">
          {isLoading ? null : (
            <button
              className="px-4 py-2 text-sm text-white duration-300 bg-gray-600 rounded-sm hover:bg-gray-800"
              onClick={onClose}
            >
              Cancel
            </button>
          )}
          {isLoading ? (
            <ArrowPathIcon className="w-10 h-10 p-2 text-white rounded-full animate-spin bg-custom-yellow" />
          ) : (
            <button
              className="px-4 py-2 text-sm text-black duration-300 rounded-sm hover:text-white bg-custom-yellow hover:bg-yellow-600"
              onClick={() => {
                setIsLoading(true);

                dispatch(
                  addShopBrand({
                    data: {
                      nameEn,
                      nameAr,
                      websitelink,
                      image,
                    },
                  })
                )
                  .unwrap()
                  .then(() => {
                    // alert("The Shop Brand has been added successfully.");
                  })
                  .catch((error) => {
                    alert("Failed to add the Shopp Brand: " + error);
                  })
                  .finally(() => {
                    setIsLoading(false);
                    setImage(null);
                    setNameEn("");
                    setNameAr("");
                    setWebsitelink("");
                    onClose();
                  });
              }}
            >
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddShopBrandsForm;
